import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';

@Injectable({
  providedIn: 'root',
})
export class SaeIntegrationsHttpService extends BaseHttpService {
  private baseURL = `sae-integrations`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getSaes() {
    let url = this.routerService.mount(`${this.baseURL}`);
    return this.read(url);
  }

}
